<template>
  <v-card>
     <v-card-title>
       <v-icon x-large>mdi-xbox-controller-menu</v-icon>
       <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Filtro"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
    :headers="headers"
    :items="usersupplier"
    :search="search"
    sort-by="calories"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="900px">
          <!--<template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">New Item</v-btn>
          </template>-->
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="6" sm="6" md="12">
                      <v-autocomplete v-model="editedItem.ApiUser_id"
                        :items="users"
                        :rules="idUserRules"
                        :item-text="'ApiUser_GivenName'"
                        :item-value="'ApiUser_id'"
                        label="User ID"
                        required
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" sm="6" md="12">
                        <v-autocomplete v-model="editedItem.ApiUser_Supplier"
                        :items="MotherSupplier"
                        :rules="idSupplierRules"
                        :item-text="'MotherSupplier_Desc'"
                        :item-value="'MotherSupplier_id'"
                        label="Proveedor"
                        required
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" sm="6" md="12">
                    <v-menu v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="editedItem.SupplierStart_Dt"
                            label="Fecha Efectiva"
                            prepend-icon="mdi-calendar-today"
                            :rules="StartDtRule"
                            readonly
                            required
                            v-bind="attrs"
                            v-on="on"
                            ></v-text-field>
                    </template>
                    <v-date-picker v-model="editedItem.SupplierStart_Dt" @input="menu = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="6" sm="6" md="12">
                    <v-menu v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="editedItem.SupplierEnd_Dt"
                            label="Fecha Fin"
                            prepend-icon="mdi-calendar-today"
                            :rules="EndDtRule"
                            readonly
                            required
                            v-bind="attrs"
                            v-on="on"
                            ></v-text-field>
                    </template>
                    <v-date-picker v-model="editedItem.SupplierEnd_Dt" @input="menu2 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_new" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="accent" dark class="mb-2" v-on="on">NUEVO USUARIO - PROVEEDOR</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                >
                  <v-row>
                    <v-col cols="6" sm="6" md="12">
                      <v-autocomplete v-model="editedItem.ApiUser_id"
                        :items="users"
                        :rules="idUserRules"
                        :item-text="'ApiUser_GivenName'"
                        :item-value="'ApiUser_id'"
                        label="User ID"
                        required
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" sm="6" md="12">
                        <v-autocomplete v-model="editedItem.ApiUser_Supplier"
                        :items="MotherSupplier"
                        :rules="idSupplierRules"
                        :item-text="'MotherSupplier_Desc'"
                        :item-value="'MotherSupplier_id'"
                        label="Proveedor"
                        required
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" sm="6" md="12">
                    <v-menu v-model="menu3"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="editedItem.SupplierStart_Dt"
                            label="Fecha Efectiva"
                            prepend-icon="mdi-calendar-today"
                            :rules="StartDtRule"
                            readonly
                            required
                            v-bind="attrs"
                            v-on="on"
                            ></v-text-field>
                    </template>
                    <v-date-picker v-model="editedItem.SupplierStart_Dt" @input="menu3 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="6" sm="6" md="12">
                    <v-menu v-model="menu4"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                    >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="editedItem.SupplierEnd_Dt"
                            label="Fecha Fin"
                            prepend-icon="mdi-calendar-today"
                            :rules="EndDtRule"
                            readonly
                            required
                            v-bind="attrs"
                            v-on="on"
                            ></v-text-field>
                    </template>
                    <v-date-picker v-model="editedItem.SupplierEnd_Dt" @input="menu4 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="close">Cancel</v-btn>
              <v-btn :disabled="!valid" color="accent" text @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn color="accent" @click="initialize">Reset</v-btn>
    </template>
  </v-data-table>
  </v-card>
</template>

<script>
import axios from 'axios'
export default {
  data: () => ({
    search: '',
    api_tool_url: process.env.VUE_APP_API_TOOL_URL,
    dialog: false,
    dialog_pass: false,
    dialog_new: false,
    valid: true,
    menu: false,
    menu2: false,
    menu3: false,
    menu4: false,
    headers: [
      { text: 'User ID', value: 'ApiUser_id' },
      { text: 'ID Proveedor', value: 'ApiUser_Supplier' },
      { text: 'Prov. Descripción', value: 'MotherSupplier_Desc' },
      { text: 'Fecha Efectiva', value: 'SupplierStart_Dt' },
      { text: 'Fecha Fin', value: 'SupplierEnd_Dt' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    usersupplier: [],
    MotherSupplier: [],
    users: [],
    editedIndex: -1,
    editedItem: {
      ApiUser_id: '',
      ApiUser_Supplier: '-1',
      SupplierStart_Dt: new Date().toISOString().substr(0, 10),
      SupplierEnd_Dt: '9999-12-31'
    },
    defaultItem: {
      ApiUser_id: '',
      ApiUser_Supplier: '-1',
      SupplierStart_Dt: new Date().toISOString().substr(0, 10),
      SupplierEnd_Dt: '9999-12-31'
    },
    idUserRules: [
      v => !!v || 'Usuario es requerido'
    ],
    idSupplierRules: [
      v => !!v || 'Proveedor es requerido'
    ],
    StartDtRules: [
      v => !!v || 'Fecha efectiva es requerida'
    ],
    EndDtRules: [
      v => !!v || 'Fecha fin es requerida'
    ],
    config: {
      headers: {
        //'Authorization': 'Bearer ' + sessionStorage.getItem('access_token'),
        "api-user": sessionStorage.getItem('ApiUser_id')
      }
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Nuevo Usuario - Proveedor' : 'Editar Usuario - Proveedor'
    },
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      axios.post(this.api_tool_url + '/get_userMotherSupplier', {}, this.config)
      .then(response => {
        this.usersupplier = response.data.ResultRows
      })
      .catch(error => {
        this.usersupplier = []
        alert(error.response.data.message)
      })

      axios.post(this.api_tool_url + '/get_mothersupplier', {}, this.config)
        .then(response => {
            this.MotherSupplier = response.data.ResultRows
        })
        .catch(error => {
          this.MotherSupplier = []
          alert(error.response.data.message)
      })

      axios.post(this.api_tool_url + '/get_users', {}, this.config)
      .then(response => {
            this.users=response.data.ResultRows
      })
      .catch(error => {
        this.users = []
        alert(error.response.data.message)
      })
      
    },

    newtItem (item) {
      this.editedIndex = this.usersupplier.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_new = true
    },

    editItem (item) {
      this.editedIndex = this.usersupplier.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.usersupplier.indexOf(item)
      confirm('Esta seguro/a de eliminar este registro?') && this.deleteUserMenu(index)
    },

    deleteUserMenu(index) {
      let usersupplier_tmp = this.usersupplier[index]
      delete usersupplier_tmp.ApiMenuOrder_id
      axios.post(this.api_tool_url + '/del_userMotherSupplier', usersupplier_tmp, this.config)
        .then(response => {
          this.usersupplier.splice(index, 1)
          this.close()
          })
        .catch(error => {
          this.usersupplier = []
          alert(error.response.data.message)
          })
    },

    close () {
      this.dialog = false
      this.dialog_new = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save () {
      //if (this.editedIndex > -1) {
        axios.post(this.api_tool_url + '/upd_ins_userMotherSupplier', this.editedItem, this.config)
        .then(response => {
          //Object.assign(this.usersupplier[this.editedIndex], response.data.ResultRows[0])
          //this.usersupplier.push(response.data.ResultRows[0])
          this.$store.commit('updateUser_Supplier',response.data.ResultRows[0])
            axios.post(this.api_tool_url + '/get_userMotherSupplier', {}, this.config)
            .then(response => {
              this.usersupplier = response.data.ResultRows
            })
            .catch(error => {
              this.usersupplier = []
              alert(error.response.data.message)
            })
          this.close()
          })
        .catch(error => {
          this.usersupplier = []
          alert(error.response.data.message)
          })
        //Object.assign(this.users[this.editedIndex], this.editedItem)
      // } else {
      //   axios.post(this.api_tool_url + '/upd_ins_userMotherSupplier', this.editedItem, this.config)
      //   .then(response => {
      //     //console.log(response)
      //     this.usersupplier.push(response.data.ResultRows[0])
      //     this.$store.commit('updateUser_Supplier',response.data.ResultRows[0])
      //     this.close()
      //   })
      //   .catch(error => {
      //     this.usersupplier = []
      //     alert(error.response.data.message)
      //   })
      // }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/UserMotherSupplierGrid.vue